import React from "react";
import Typography from "@mui/material/Typography";
import { styled, Theme } from "@mui/material";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { grey } from "@mui/material/colors";

// TBD: should be moved into a theme, or style object
//export const CONDENSED_FONT = "Helvetica Neue";
//export const CHROME_ELEMENTS_FONT = "Helvetica Neue";
//export const CHROME_ELEMENTS_FONT_MD = "Helvetica Neue md";
//export const CONDENSED_FONT_LT = "Helvetica Neue lt";

export const CONDENSED_FONT = "Poppins";
export const CHROME_ELEMENTS_FONT = CONDENSED_FONT;
export const CHROME_ELEMENTS_FONT_MD = CONDENSED_FONT;
export const CONDENSED_FONT_LT = CONDENSED_FONT;

export const CondensedTypography = styled(
  ({
    ...props
  }: {
    className?: string;
    children?: any;
    onClick?: (e: any) => void;
    display?: string;
  }) => (
    <Typography
      component={"div"}
      {...props}
      className={
        props.className
          ? `${props.className} kahun-condensed`
          : `kahun-condensed`
      }
    />
  ),
)(({ theme }) => ({
  fontFamily: CONDENSED_FONT,
  fontSize: "14px",
  // JM: I cant seem to take the font from a theme parameter - the next line doesnt work
  // fontFamily: theme.typography.caption.fontFamily,
  fontWeight: 500,
}));
export const CondensedTypographyMedium = styled(Typography)(({ theme }) => ({
  fontFamily: CHROME_ELEMENTS_FONT_MD,
  fontSize: "14px",
  // JM: I cant seem to take the font from a theme parameter - the next line doesnt work
  // fontFamily: theme.typography.caption.fontFamily,
  fontWeight: 500,
}));

export const ChromeTypography = styled(Typography)(
  ({ theme }: { theme?: Theme; children?: any }) => ({
    fontFamily: CHROME_ELEMENTS_FONT,
    // JM: I cant seem to take the font from a theme parameter - the next line doesnt work
    // fontFamily: theme.typography.caption.fontFamily,
  }),
);

export const KahunPrimaryTypography = styled(CondensedTypography)({
  color: KahunColorMap.Primary,
  fontSize: "16px",
});

export const KahunPrimaryTypographySmall = styled(CondensedTypography)({
  color: KahunColorMap.Primary,
  fontSize: "14px",
});

export const KahunSecondaryTypography = styled(CondensedTypography)({
  color: grey[500],
  fontSize: "14px",
});

export const KahunMetricTypography = styled(KahunPrimaryTypography)({
  fontFamily: CONDENSED_FONT_LT,
});

export const KahunTitle = styled(CondensedTypography)({
  color: KahunColorMap.Primary,
  fontFamily: CONDENSED_FONT_LT,
});

export const KahunAccentTypography = styled(CondensedTypography)({
  color: KahunColorMap.Accent,
  fontSize: "16px",
  fontWeight: "bolder",
});
export const SelectionBox = styled("div")({
  borderLeftWidth: 3,
  borderLeftColor: KahunColorMap.Accent,
});
